import React, { useState } from "react";
import Modal from '@material-ui/core/Modal';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";

import SearchAccordion from "./SearchCard";
import DownloadFile from "./downloadFile";

import './style.css'

export default function SearchTable({
  filteredData,
  searchValue,
  vocabularies,
  curLang,
  languages,
  selectedLang,
  maxScore,
}) {

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedRegime, setSelectedRegime] = useState(null);

  const openModal = (regimeValue) => {
    setModalOpen(true);
    setSelectedRegime(regimeValue)

  };

  const closeModal = () => {
    setModalOpen(false);
  };

  searchValue = searchValue.toUpperCase();

  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [DrawerData, setDrawerData] = useState({});

  const findRelevantScoreColor = score => {
    if (score) {
      score = score.toFixed(2);
      let relevant_score = 1 - ((maxScore - score) / maxScore);
      relevant_score = relevant_score.toFixed(2);
      if (relevant_score >= parseFloat(process.env.REACT_APP_LOW_SCORE_START)
        && relevant_score <= parseFloat(process.env.REACT_APP_LOW_SCORE_END)) {
        return process.env.REACT_APP_LOW_SCORE_COLOR;
      } else if (relevant_score >= parseFloat(process.env.REACT_APP_MEDIUM_SCORE_START)
        && relevant_score <= parseFloat(process.env.REACT_APP_MEDIUM_SCORE_END)) {
        return process.env.REACT_APP_MEDIUM_SCORE_COLOR;
      } else if (relevant_score >= parseFloat(process.env.REACT_APP_HIGH_SCORE_START)
        && relevant_score <= parseFloat(process.env.REACT_APP_HIGH_SCORE_END)) {
        return process.env.REACT_APP_HIGH_SCORE_COLOR;
      }
    }
    return "";
  }

  const getScoreToolTip = score => {
    let scoreColor = findRelevantScoreColor(score);
    if (scoreColor === process.env.REACT_APP_LOW_SCORE_COLOR) {
      return vocabularies[curLang]["new"]["information"][11];
    } else if (scoreColor === process.env.REACT_APP_MEDIUM_SCORE_COLOR) {
      return vocabularies[curLang]["new"]["information"][12];
    } else if (scoreColor === process.env.REACT_APP_HIGH_SCORE_COLOR) {
      return vocabularies[curLang]["new"]["information"][13];
    }
  }

  return (
    <>
      {
        toggleDrawer &&
        <SearchAccordion
          languages={languages}
          searchLang={selectedLang}
          toggleDrawer={toggleDrawer}
          onCloseDrawer={() => setToggleDrawer(false)}
          row={DrawerData}
          vocabularies={vocabularies}
        />
      }
      <TableContainer className="search-table-container" component={Paper} >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="search-table-cell">{vocabularies[curLang]['search']['score']}</TableCell>
              <TableCell className="search-table-cell">{vocabularies[curLang]['search']['fullName']}</TableCell>
              <TableCell className="search-table-cell">{vocabularies[curLang]['search']['recordType']}</TableCell>
              <TableCell className="search-table-cell">{vocabularies[curLang]['search']['permenantReferenceNumber']}</TableCell>
              <TableCell className="search-table-cell">{vocabularies[curLang]['search']['regime']}</TableCell>
              <TableCell className="search-table-cell">{vocabularies[curLang]['download']['Download']}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length ? filteredData.map((row) => (
              <TableRow
              onClick={() => {
                setToggleDrawer(true);
                setDrawerData(row);
              }}
                key={Math.random()}
              >
                <TableCell className="search-table-body-cell"
                  title={getScoreToolTip(row['@search.score'])}
                  style={{ color: `${findRelevantScoreColor(row['@search.score'])}`, fontWeight: 'bold' }}>
                  {(row['@search.score']).toFixed(2)}
                </TableCell>
                <TableCell className="search-table-body-cell">
                  {row.scSanctionEntry.entry.languages[curLang === 'CN' ? 'CH' : curLang].identity[0].names.name[0].value}
                </TableCell>
                <TableCell className="search-table-body-cell">{row.scSanctionEntry.entry.languages[curLang === 'CN' ? 'CH' : curLang].entryType}</TableCell>
                <TableCell className="search-table-body-cell">{row.scSanctionEntry.entry.languages[curLang === 'CN' ? 'CH' : curLang].referenceNumber}</TableCell>
                <TableCell className="search-table-body-cell">{row.scSanctionEntry.entry.languages[curLang === 'CN' ? 'CH' : curLang].listName}</TableCell>
                <TableCell className="search-table-body-cell">
                  <Button onClick={(event) => {
                        event.stopPropagation();
                        openModal(row.scSanctionEntry.entry.languages[curLang === 'CN' ? 'CH' : curLang].listName)}}>
                    <CloudDownloadIcon />
                  </Button>
                </TableCell>
              </TableRow>
            )) : null}
          </TableBody>
        </Table>
      </TableContainer>

       {/* DownloadFile Modal */}
       <Modal open={isModalOpen}>
        <div className="modal-content">
          <DownloadFile 
          curLang={curLang}
          vocabularies={vocabularies}
          languages={languages}
          regime={selectedRegime}
          onClose={closeModal}
          />
        </div>
      </Modal>
    </>
  )
}
